<template>
  <el-dialog 
    class="message-dialog" width="800px" 
    :visible.sync="state" 
    :close-on-click-modal="false" 
    :close-on-press-escape="false" 
    :show-close="false">
    <div class="message-detail">
      <div v-if="messageContent">
        <p class="ta-c fs-18 fw-b">{{messageContent.msgTitle}}</p>
        <p v-html="messageContent.msgContent" class="message-content"></p>
        <!-- <p class="ta-r mr-20 mt-10 mb-10">{{'发布人:' + messageContent.msgPublisher }}</p>
        <p class="ta-r mr-20 mt-10 mb-10">{{'发布时间:' + messageContent.publishTime}}</p> -->
      </div>
      <div class="ta-c">
        <div v-if="checkType === 'important'">
          <el-button @click="hasRead" type="primary" size="mini" :disabled="showTime !== 0">
            {{ (`${ activeIndex === messageInfo.length - 1 ? '已阅读' : '下一条'}` + `${showTime ? '('+showTime+ '秒)': ''}`)}}
          </el-button>
        </div>
        <el-button v-else @click="$emit('close')" type="primary" size="mini">关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {mapActions,mapMutations} from 'vuex'
import { Req_ReadMsg } from '@/request/user'
import { deepClone } from '@/util'
export default {
  name: 'MessageDetailBox',
  props: {
    state: {
      type: Boolean,
      default: false
    },
    messageInfo: {
      type: Array,
      defautl: () => []
    },
    checkType: {
      type: String,
      default: 'important'
    }
  },
  data() {
    return {
      timer: null,
      showTime: '',
      activeIndex: 0,
      messageContent: null
    }
  },
  created(){
    this.messageContent = this.messageInfo[this.activeIndex]
    if(this.checkType === 'important' && this.messageInfo.length) this.initTimer()
  },
  methods: {
    ...mapMutations(['initShowMessageStatus','setMessageTimer']),
    ...mapActions(['setUnreadCount']),
    initTimer(){
      this.showTime = deepClone(this.messageInfo[this.activeIndex].showTime)
      this.timer = setInterval(() => {
        if(this.showTime > 0) {
          --this.showTime 
        }else{
          this.timer && this.clearTimer()
        }
      },1000)
    },
    clearTimer(){
      clearInterval(this.timer)
      this.timer = null
    },
    hasRead(){
      if(this.checkType === 'check'){
        return this.$emit('close')
      }else{
        this.read()
      }
    },
    read(){ 
      return Req_ReadMsg({
        msgId: this.messageInfo[this.activeIndex].msgId
      }).then(res => {
        this.setUnreadCount()
        if(this.activeIndex === this.messageInfo.length - 1)  {
          this.initShowMessageStatus()
          this.setMessageTimer()
        }else {
          this.turnPage()
        }       
      }).catch(err  => this.$catchErr(err))
    },
    turnPage(){
      if(this.activeIndex < this.messageInfo.length - 1) ++this.activeIndex
      this.messageContent = this.messageInfo[this.activeIndex]
      this.initTimer()
    }
  },
  watch: {
    state(nV) {
      if(nV) {
        this.activeIndex = 0
        this.messageContent = this.messageInfo[0]
        this.initTimer() 
      }else {
        this.clearTimer()
      }
    }
  }
}
</script>
<style lang="scss">
  .message-dialog {
    .el-dialog__header {
      background: #3E3A39;
    }
    .el-dialog__body {
      padding: 15px 20px;
    }
  }
  .message-detail {
    .message-content{ 
      font-size: 16px;
      max-width: 715px;
      height: 380px;
      overflow: auto;
      margin: 20px auto;
      a {
        color: #409EEF;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Util/MessageUtil.vue